import React from "react";
import { Star } from "lucide-react";
import Reveal from "../Reveal";
import { REVIEWS, REVIEW_RATING, REVIEW_COUNT } from "../../../lib/site";
import { useGoogleReviews } from "../../../lib/useGoogleReviews";

const Reviews = ({ limit }) => {
  const g = useGoogleReviews();
  const live = g.configured && g.reviews && g.reviews.length > 0;
  const rating = (g.configured && g.rating ? g.rating : REVIEW_RATING).toFixed(1);
  const total = g.configured && g.total ? g.total : REVIEW_COUNT;
  const source = live
    ? g.reviews.map((r) => ({ name: r.author, meta: r.relative_time, text: r.text, rating: r.rating || 5 }))
    : REVIEWS.map((r) => ({ name: r.name, meta: r.city, text: r.text, rating: 5 }));
  const list = limit ? source.slice(0, limit) : source;

  return (
    <section className="py-20 md:py-24 bg-[#0A0A0A]" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-12">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-[#C69453] text-sm font-semibold tracking-[0.2em] uppercase">What Neighbors Say</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-light text-white mt-2">
            Rated {rating} Stars on Google
          </h2>
          <div className="flex items-center justify-center gap-1 text-yellow-400 mt-4">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-current" />)}
          </div>
          <p className="text-zinc-400 mt-3">{total} reviews and counting</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {list.map((r, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <div className="border border-zinc-800 bg-[#141414] p-7 h-full flex flex-col" data-testid="review-card">
                <div className="flex text-yellow-400 mb-4">
                  {[...Array(r.rating)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" />)}
                </div>
                <p className="text-zinc-300 text-base leading-relaxed flex-grow line-clamp-[10]">&ldquo;{r.text}&rdquo;</p>
                <div className="mt-5 pt-4 border-t border-zinc-900 flex items-center justify-between">
                  <div>
                    <p className="text-white font-bold">{r.name}</p>
                    <p className="text-zinc-500 text-sm">{r.meta}</p>
                  </div>
                  {live && <span className="text-zinc-600 text-xs uppercase tracking-widest">Google</span>}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {live && g.url && (
          <div className="text-center mt-12">
            <a href={g.url} target="_blank" rel="noopener noreferrer" data-testid="reviews-google-link-home" className="inline-flex items-center gap-2 text-[#C69453] font-semibold hover:gap-3 transition-all">
              {g.total ? `Read all ${g.total} reviews on Google →` : "See our Google reviews →"}
            </a>
          </div>
        )}
      </div>
    </section>
  );
};

export default Reviews;
